// extracted by mini-css-extract-plugin
export var li = "_vp-2";
export var ol = "_vp-1";
export var ul = "_vp-0";